import { call, put, takeEvery } from 'redux-saga/effects'
import * as donTuActions from '@redux/ducks/donTu.Ducks'
import * as donTuApi from '@apis/donTu/donTu.Api'
import * as nghiPhepApi from '@apis/donTu/nghiPhep.Api'
import * as lichLamViecApi from '@apis/donTu/caLamViec.Api'
import * as quyTrinhDuyetApi from '@apis/donTu/quyTrinhDuyet.Api'

// Đơn từ
function* fetchDanhSachDonTu({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof donTuApi.locDanhSachDonTu> = yield call(donTuApi.locDanhSachDonTu, params)
    yield put(donTuActions.layDanhSachDonTuThanhCong(res))
  } catch (error) {
    yield put(donTuActions.layDanhSachDonTuThatBai(error))
  }
}

// Duyệt đơn
function* fetchDanhSachDuyetDon({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof donTuApi.layDonTuChoXuLy> = yield call(donTuApi.layDonTuChoXuLy, params.approverId || 0)
    yield put(donTuActions.layDanhSachDuyetDonThanhCong(res))
  } catch (error) {
    yield put(donTuActions.layDanhSachDuyetDonThatBai(error))
  }
}

// Đơn nghỉ phép
function* fetchDanhSachNghiPhep({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof nghiPhepApi.layLichSuNghiPhep> = yield call(nghiPhepApi.layLichSuNghiPhep, params)
    yield put(donTuActions.layDanhSachNghiPhepThanhCong(res))
  } catch (error) {
    yield put(donTuActions.layDanhSachNghiPhepThatBai(error))
  }
}

// Lịch làm việc
function* fetchDanhSachLichLamViec({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof lichLamViecApi.layDanhSachLichLamViec> = yield call(lichLamViecApi.layDanhSachLichLamViec, params)
    yield put(donTuActions.layDanhSachLichLamViecThanhCong(res))
  } catch (error) {
    yield put(donTuActions.layDanhSachLichLamViecThatBai(error))
  }
}

// Quy trình duyệt
function* fetchDanhSachQuyTrinhDuyet() {
  try {
    const res: ReturnType<typeof quyTrinhDuyetApi.layDanhSachCauHinhWorkflow> = yield call(quyTrinhDuyetApi.layDanhSachCauHinhWorkflow)
    yield put(donTuActions.layDanhSachQuyTrinhDuyetThanhCong(res))
  } catch (error) {
    yield put(donTuActions.layDanhSachQuyTrinhDuyetThatBai(error))
  }
}

export default function* watchDonTu() {
  yield takeEvery(donTuActions.layDanhSachDonTu.toString(), fetchDanhSachDonTu)
  yield takeEvery(donTuActions.layDanhSachDuyetDon.toString(), fetchDanhSachDuyetDon)
  yield takeEvery(donTuActions.layDanhSachNghiPhep.toString(), fetchDanhSachNghiPhep)
  yield takeEvery(donTuActions.layDanhSachLichLamViec.toString(), fetchDanhSachLichLamViec)
  yield takeEvery(donTuActions.layDanhSachQuyTrinhDuyet.toString(), fetchDanhSachQuyTrinhDuyet)
}

